import React from "react";
import { IconAlertCircle } from "@tabler/icons-react";
import Button from "components/Button";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "assets/images/check-circle-green.svg";
import { ArrowRightIcon } from "@heroicons/react/outline";
import LoadingView from "../components/LoadingView";

const CreateExport = ({
  onFinish,
  loading,
  fileCreated,
  inProgressMessage,
  navigateToExports,
}: {
  onFinish: () => void;
  loading: boolean;
  fileCreated: boolean;
  inProgressMessage: string;
  navigateToExports: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {loading && <LoadingView />}
      {fileCreated && (
        <div className="space-y-4 text-center items-center flex flex-col justify-center">
          <img className="w-12" src={CheckCircleIcon} alt="check-circle" />
          <label className="font-[600] text-lg text-gray-900">
            {t("certExport.fileCreated")}
          </label>
          <label className="font-[400] text-sm text-gray-700">
            {t("certExport.fileCreatedDescription")}
          </label>
          <div className="flex justify-between w-full gap-4">
            <Button className="w-full" type="gray" onClick={onFinish}>
              {t("certExport.seeLater")}
            </Button>
            <Button
              className="w-full"
              type="primary"
              onClick={navigateToExports}
              trailingIcon={<ArrowRightIcon />}
            >
              {t("certExport.openExports")}
            </Button>
          </div>
        </div>
      )}

      {inProgressMessage && (
        <div className="space-y-4 text-center items-center flex flex-col justify-center">
          <IconAlertCircle className="w-12 h-12" color="red" />
          <label className="font-[600] text-lg text-gray-900">
            {t("certExport.fileInProgress")}
          </label>
          <label className="font-[400] text-sm text-gray-700">
            {inProgressMessage}
          </label>
          <Button type="primary" onClick={onFinish}>
            {t("certExport.iUnderstand")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CreateExport;
